import { useQuery } from "@tanstack/react-query";
import i18n from "@/i18n";
import { getPublicAssetUrl } from "@/loadConfig";

export type InstructionTranslation = {
  language: string;
  title: string;
  videoUrl: string;
};

export type Instruction = {
  code: string;
  category: string;
  sortOrder: number;
  isActive: boolean;
  translations: InstructionTranslation[];
};

type InstructionsResponse = {
  instructions: Instruction[];
};

export const instructionKeys = {
  all: () => ["instructions", i18n.language] as const,
  list: () => [...instructionKeys.all(), "list"] as const,
};

export const useInstructions = (enabled: boolean = true) => {
  return useQuery({
    queryKey: instructionKeys.list(),
    queryFn: async () => {
      const response = await fetch(getPublicAssetUrl("instructions.json"), {
        headers: {
          Accept: "application/json",
        },
      });

      if (!response.ok) {
        throw new Error(`Failed to load instructions.json: ${response.status}`);
      }

      const data = (await response.json()) as InstructionsResponse;
      return data.instructions ?? [];
    },
    enabled,
  });
};
